/**
 * @generated SignedSource<<611b30207dc32146a099c43ab3273633>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InquiryContextProvider_userAccount$data = {
  readonly createdJobPostings: {
    readonly count: number;
  };
  readonly paidProjectsV2: {
    readonly count: number;
  };
  readonly " $fragmentType": "InquiryContextProvider_userAccount";
};
export type InquiryContextProvider_userAccount$key = {
  readonly " $data"?: InquiryContextProvider_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"InquiryContextProvider_userAccount">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InquiryContextProvider_userAccount",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "source": "PAID_PROJECT_INQUIRY"
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "UserAccountPaidProjectV2Connection",
      "kind": "LinkedField",
      "name": "paidProjectsV2",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "paidProjectsV2(filter:{\"source\":\"PAID_PROJECT_INQUIRY\"},first:1)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": [
              "APPROVED",
              "ARCHIVED",
              "PENDING",
              "PENDING_REVISION",
              "EXPIRED"
            ]
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "UserAccountCreatedJobPostingsConnection",
      "kind": "LinkedField",
      "name": "createdJobPostings",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "createdJobPostings(filter:{\"status\":[\"APPROVED\",\"ARCHIVED\",\"PENDING\",\"PENDING_REVISION\",\"EXPIRED\"]},first:1)"
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};
})();

(node as any).hash = "59c172040140a4fb26a6e5972b7b3cc6";

export default node;
